import React from "react";

const es_default_by_merchant = {
  //WelcomeBack messages:
  PROPOSAL_DETAILS: "Propuesta enviada a $v1 por un importe de $v2€",
  PROPOSAL_DETAILS_WITHOUT_AMOUNT: "Propuesta enviada a $v1",

  //Welcome
  INVITATION_MSG:
    "Estás a punto de empezar el proceso de solicitud de tu cliente $v1",
  NIE_EU_PASSPORT:
    "En caso de tener NIE Europeo sin foto, pediremos el pasaporte de tu cliente.",
  INCOME: "Ingresos",
  SPANISH_ACCOUNT_DETAIL:
    "Se deberá cargar el documento de ingresos (nómina, pensión u otros) y el justificante de titularidad de cuenta bancaria de tu cliente",
  YOUR_LOAN_PROCESS:
    "Así será el proceso de solicitud para financiar a tu cliente",
  LOAN_ADJUSTMENT_AND_EVALUATION: "Evaluación de la solicitud de tu cliente",

  //KYC Manual:
  DOCUMENT_TYPE: "Tipo de documento de tu cliente",
  NAME_SURNAME: "Nombre y apellidos de tu cliente",
  BIRTH_DATA: "Datos de nacimiento de tu cliente",
  IMAGE_ID: "Imagen del documento de tu cliente",

  //Additional Data
  IMAGE_ID_NIE_EU: "Imagen del pasaporte de tu cliente",
  CURRENT_RESIDENCE_ADDRESS: "Dirección actual de residencia de tu cliente",
  ADDRESS_DIALOG_TITLE: "Dirección actual de residencia de tu cliente",
  HOME_INFO: "Datos del domicilio actual de tu cliente",
  MY_CURRENT_ADDRESS_IS: "El domicílio actual del cliente es",
  YOUR_PART: "(parte proporcional del cliente)",
  FAMILY_SITUATION: "Situación familiar de tu cliente",
  OWNERSHIP: "De su propiedad",

  //Declared Income:
  PROVIDE_MAIN_INCOME_SOURCE:
    "Indica la principal fuente de ingreso de tu cliente",
  DIRECT_DEBIT_ACCOUNT: "Domiciliación de tu cliente",
  BANK_ACCOUNT_IBAN: "Cuenta de domiciliación de tu cliente",

  //Professional Data:
  EMPLOYMENT_STATUS: "Situación laboral de tu cliente",
  COMPANY_INFO: "Datos de la compañía donde trabaja tu cliente",

  //SummaryAndAdjust:
  YOUR_LOAN_RESULT: "¡El proceso para tu cliente ya casi está!",
  APPLY_FOR_LOAN_BODY:
    "La solicitud no es vinculante hasta que tu cliente no firme el contrato digitalmente. Recibirá un correo electrónico con las instrucciones para completar ese paso.",
  DATA_TREATMENT: "Tratamiento de datos de tu cliente",
  //Application Info:
  LOAN_ANALYSING: (
    <span>
      <span>
        Hemos lanzado la solicitud de tu cliente a las entidades financieras y
        te contestaremos pronto. ¡Estáte atent@!
      </span>
      &nbsp;
      <p>
        <span>
          Puedes cerrar esta ventana y reanudar el proceso cuando las entidades
          financieras analicen esta solicitud.
        </span>
        <p>
          Puedes volver a abrir la solicitud desde la pantalla de detalle de la
          operación.
        </p>
      </p>
    </span>
  ),
  PLEASE_WAIT_APPLICATION:
    "Por favor espera un momento, estamos procesando la solicitud de tu cliente. Este proceso puede durar hasta 1 minuto.",

  //Documentation:
  DOCUMENTATION_UPLOAD:
    "Por favor, sube los siguientes documentos de tu cliente",

  //Application info messages
  RESUME_LOAN_PROCESS: "Continúa el proceso de tu cliente donde lo dejaste.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED:
    "¡La solicitud de tu cliente ha sido preaprobada y está pendiente de validación!",
  DOCS_PENDING_INFO:
    "¡Sube ahora la documentación de tu cliente para obtener la confirmación final más rápidamente!",
  SIGNATURE_PENDING_INFO:
    "Es necesario que tu cliente firme el contrato digitalmente",
  SIGNATURE_PENDING_BY_MAIL_INFO_MESSAGE:
    "Tu cliente deberá revisar su correo electrónico y firmar desde cualquier dispositivo.",
  LOAN_HAS_BEEN_DENIED: "La solicitud de tu cliente no ha sido aprobada",
  SYSTEM_FAILURE_DETECTION:
    "El perfil de tu cliente no se adapta a las políticas de riesgo de las entidades financieras colaboradoras.",
};

export default es_default_by_merchant;
